// Vue.js
import Vue from "vue";
import VueFuse from "vue-fuse";
import VModal from "vue-js-modal";
import ToggleButton from "vue-js-toggle-button";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import i18n from "./i18n";

// Firebase
import firebase from "firebase/app";
import 'firebase/firestore';

// Tailwind
import "./assets/css/tailwind.css";
import Zondicon from 'vue-zondicons';

Vue.component('Zondicon', Zondicon);

// FontAwesome
import { dom, config, library } from '@fortawesome/fontawesome-svg-core';
import { faHome, faUser, faUsers, faCubes, faAngleRight, faCheckCircle, faExclamationTriangle,
         faInfoCircle, faExclamationCircle, faChevronLeft, faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

config.searchPseudoElements = true;
dom.watch();

library.add(faHome, faUser, faUsers, faCubes, faAngleRight,
            faCheckCircle, faExclamationTriangle,
            faInfoCircle, faExclamationCircle, faChevronLeft, faArrowDown, faArrowUp);

Vue.component('Fa', FontAwesomeIcon);

Vue.prototype.$axios = axios;
Vue.prototype.$firebase = firebase;

Vue.use(ToggleButton)
Vue.use(VueFuse)
Vue.use(VModal)

Vue.config.productionTip = false;

// use beforeEach route guard to set the language
router.beforeEach((to, from, next) => {

  // use the language from the routing param or default language
  let language = to.params.lang;
  if (!language) {
    language = 'de'
  }

  // set the current language for i18n.
  i18n.locale = language
  next()
})

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCeMo9tcNpnLq0rXp1gSiR40pBazlgUoyY",
  authDomain: "duwdev-firebase-auth.firebaseapp.com",
  databaseURL: "https://duwdev-firebase-auth.firebaseio.com",
  projectId: "duwdev-firebase-auth",
  storageBucket: "duwdev-firebase-auth.appspot.com",
  messagingSenderId: "109106319969",
  appId: "1:109106319969:web:9937dce40e1fe418cf5020"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

let app;

firebase.auth().onAuthStateChanged(() => {
  if(!app) {
    app = new Vue({
      router,
      i18n,
      store,
      render: h => h(App)
    }).$mount("#app");
  }
})